// Generated by scripts/generate-tool-directory.ts; do not edit manually.
export const TOOL_DIRECTORY = [
  {
    "name": "교원 채용 지도",
    "route": "/workmate/teacher-jobs",
    "section": "workmate",
    "guide": "/guide/workmate/teacher-jobs"
  },
  {
    "name": "포스터 만들기",
    "route": "/workmate/poster-studio",
    "section": "workmate",
    "guide": "/guide/workmate/poster-studio"
  },
  {
    "name": "학교 문서 모아받기",
    "route": "/workmate/school-documents",
    "section": "workmate",
    "guide": "/guide/workmate/school-documents"
  },
  {
    "name": "파일 변환",
    "route": "/workmate/file-converter",
    "section": "workmate",
    "guide": "/guide/workmate/file-converter"
  },
  {
    "name": "생활기록부 문구 생성",
    "route": "/workmate/student-record",
    "section": "workmate",
    "guide": "/guide/workmate/student-record"
  },
  {
    "name": "평가 계획 작성",
    "route": "/workmate/evaluation-plan",
    "section": "workmate",
    "guide": "/guide/workmate/evaluation-plan"
  },
  {
    "name": "시험 문항 배점 생성기",
    "route": "/workmate/exam-score",
    "section": "workmate",
    "guide": "/guide/workmate/exam-score"
  },
  {
    "name": "논술형 평가 채점",
    "route": "/workmate/essay-grading",
    "section": "workmate",
    "guide": "/guide/workmate/essay-grading"
  },
  {
    "name": "문제·학습지 만들기",
    "route": "/workmate/worksheet-restore",
    "section": "workmate",
    "guide": "/guide/workmate/worksheet-restore"
  },
  {
    "name": "에듀파인 품의 엑셀",
    "route": "/workmate/purchase-order",
    "section": "workmate",
    "guide": "/guide/workmate/purchase-order"
  },
  {
    "name": "영수증 자동정리",
    "route": "/workmate/receipts",
    "section": "workmate",
    "guide": "/guide/workmate/receipts"
  },
  {
    "name": "학급 편성",
    "route": "/workmate/re-class",
    "section": "workmate",
    "guide": "/guide/workmate/re-class"
  },
  {
    "name": "사진·한글 수식 편집",
    "route": "/workmate/latex-to-hwp",
    "section": "workmate",
    "guide": "/guide/workmate/latex-to-hwp"
  },
  {
    "name": "맞춤 GPT",
    "route": "/workmate/custom-gpt",
    "section": "workmate",
    "guide": "/guide/workmate/custom-gpt"
  },
  {
    "name": "시험 감독시간표",
    "route": "/workmate/exam-supervision",
    "section": "workmate",
    "guide": "/guide/workmate/exam-supervision"
  },
  {
    "name": "우리학교 시간표",
    "route": "/workmate/timetable",
    "section": "workmate",
    "guide": "/guide/workmate/timetable-personal"
  },
  {
    "name": "뚝딱 서류 수합기",
    "route": "/workmate/consent-form",
    "section": "workmate",
    "guide": "/guide/workmate/consent-form"
  },
  {
    "name": "자료 수합",
    "route": "/workmate/collect/dashboard",
    "section": "workmate",
    "guide": "/guide/workmate/collect"
  },
  {
    "name": "AI 파일 수합",
    "route": "/workmate/file-inbox",
    "section": "workmate",
    "guide": "/guide/workmate/file-inbox"
  },
  {
    "name": "등록부 서명 수합기",
    "route": "/workmate/registry",
    "section": "workmate",
    "guide": "/guide/workmate/registry"
  },
  {
    "name": "문서 서명 받기",
    "route": "/workmate/document-sign",
    "section": "workmate",
    "guide": "/guide/workmate/document-sign"
  },
  {
    "name": "연수 이수증 수합",
    "route": "/workmate/training-certs",
    "section": "workmate",
    "guide": "/guide/workmate/training-certs"
  },
  {
    "name": "AI HWPX 문서 자동생성",
    "route": "/workmate/hwpx-fill",
    "section": "workmate",
    "guide": "/guide/workmate/hwpx-fill"
  },
  {
    "name": "익명 학교 대화",
    "route": "/workmate/school-conversation",
    "section": "workmate",
    "guide": "/guide/workmate/school-conversation"
  },
  {
    "name": "학교 희망 도서 구입 신청",
    "route": "/workmate/book-requests",
    "section": "workmate",
    "guide": "/guide/workmate/book-requests"
  },
  {
    "name": "분실물 관리",
    "route": "/workmate/lost-found",
    "section": "workmate",
    "guide": "/guide/workmate/lost-found"
  },
  {
    "name": "물품 대여 관리",
    "route": "/workmate/equipment-loan",
    "section": "workmate",
    "guide": "/guide/workmate/equipment-loan"
  },
  {
    "name": "온라인 교무실 만들기",
    "route": "/workmate/office-builder",
    "section": "workmate",
    "guide": "/guide/workmate/office-builder"
  },
  {
    "name": "스피치 발음 평가",
    "route": "/classmate/reading-assessment",
    "section": "classmate",
    "guide": "/guide/classmate/reading-assessment"
  },
  {
    "name": "생기부 스튜디오",
    "route": "/classmate/record-studio",
    "section": "classmate",
    "guide": "/guide/classmate/record-studio"
  },
  {
    "name": "학급 관리",
    "route": "/classmate/classrooms",
    "section": "classmate",
    "guide": "/guide/classmate/classrooms"
  },
  {
    "name": "자리 배치",
    "route": "/classmate/arrangements",
    "section": "classmate",
    "guide": "/guide/classmate/arrangements"
  },
  {
    "name": "출석 관리",
    "route": "/classmate/attendance-management",
    "section": "classmate",
    "guide": "/guide/classmate/attendance-management"
  },
  {
    "name": "마음관계 분석",
    "route": "/classmate/sociometry",
    "section": "classmate",
    "guide": "/guide/classmate/sociometry"
  },
  {
    "name": "익명 투표",
    "route": "/classmate/votes",
    "section": "classmate",
    "guide": "/guide/classmate/votes"
  },
  {
    "name": "원픽 투표",
    "route": "/classmate/onepick",
    "section": "classmate",
    "guide": "/guide/classmate/onepick"
  },
  {
    "name": "수업 진도 · 출석",
    "route": "/classmate/progress",
    "section": "classmate",
    "guide": "/guide/classmate/progress"
  },
  {
    "name": "활동 기록",
    "route": "/classmate/activities",
    "section": "classmate",
    "guide": "/guide/classmate/activities"
  },
  {
    "name": "우리 반 사진함",
    "route": "/classmate/albums",
    "section": "classmate",
    "guide": "/guide/classmate/albums"
  },
  {
    "name": "우리 반 담벼락",
    "route": "/classmate/walls",
    "section": "classmate",
    "guide": "/guide/classmate/walls"
  },
  {
    "name": "실시간 워드 클라우드",
    "route": "/classmate/wordcloud",
    "section": "classmate",
    "guide": "/guide/classmate/wordcloud"
  },
  {
    "name": "퀴즈 스튜디오 (스피드 퀴즈 배틀)",
    "route": "/classmate/quiz-battle",
    "section": "classmate",
    "guide": "/guide/classmate/quiz-battle"
  },
  {
    "name": "학생 문제 배틀",
    "route": "/classmate/peer-quiz",
    "section": "classmate",
    "guide": "/guide/classmate/peer-quiz"
  },
  {
    "name": "시크릿 16",
    "route": "/classmate/secret16",
    "section": "classmate",
    "guide": "/guide/classmate/secret16"
  },
  {
    "name": "카드 뒤집기",
    "route": "/classmate/games",
    "section": "classmate",
    "guide": "/guide/classmate/card-flip-games"
  },
  {
    "name": "논술형 평가",
    "route": "/classmate/essay-grading",
    "section": "classmate",
    "guide": "/guide/classmate/essay-grading"
  },
  {
    "name": "전자칠판",
    "route": "/classmate/board",
    "section": "classmate",
    "guide": "/guide/classmate/board"
  },
  {
    "name": "수업 타이머",
    "route": "/classmate/timer",
    "section": "classmate",
    "guide": "/guide/classmate/timer"
  },
  {
    "name": "랜덤 뽑기",
    "route": "/classmate/random-pick",
    "section": "classmate",
    "guide": "/guide/classmate/random-pick"
  },
  {
    "name": "QR 코드 생성",
    "route": "/classmate/qr",
    "section": "classmate",
    "guide": "/guide/classmate/qr"
  },
  {
    "name": "전입·전보 학교 미리보기",
    "route": "/informate/schools",
    "section": "informate",
    "guide": "/guide/informate/informate-schools"
  },
  {
    "name": "교사들의 책",
    "route": "/informate/books",
    "section": "informate",
    "guide": "/guide/informate/informate-books"
  },
  {
    "name": "교사들의 유튜브",
    "route": "/informate/youtubers",
    "section": "informate",
    "guide": "/guide/informate/informate-youtubers"
  },
  {
    "name": "교사들의 블로그",
    "route": "/informate/blogers",
    "section": "informate",
    "guide": "/guide/informate/informate-blogers"
  },
  {
    "name": "교사 MBTI",
    "route": "/informate/mbti",
    "section": "informate",
    "guide": "/guide/informate/informate-mbti"
  },
  {
    "name": "교사 오픈채팅",
    "route": "/informate/openchats",
    "section": "informate",
    "guide": "/guide/informate/informate-openchats"
  },
  {
    "name": "교사들의 바이브코딩",
    "route": "/informate/vibe-sites",
    "section": "informate",
    "guide": "/guide/informate/informate-vibe-sites"
  },
  {
    "name": "시간표 자동 생성 · 관리",
    "route": "/timetable/schools",
    "section": "timetable",
    "guide": "/guide/timetable"
  },
  {
    "name": "소통공간 게시판",
    "route": "/community/board",
    "section": "community",
    "guide": "/guide/community/community-board"
  },
  {
    "name": "글쓰기 · 댓글 · 반응",
    "route": "/community/board/new",
    "section": "community",
    "guide": "/guide/community/community-post"
  },
  {
    "name": "팔로우 · 메모",
    "route": "/follows",
    "section": "community",
    "guide": "/guide/community/community-follow"
  },
  {
    "name": "쪽지 · 알림",
    "route": "/messages",
    "section": "community",
    "guide": "/guide/community/community-messages"
  },
  {
    "name": "로그인 · 회원가입",
    "route": "/login",
    "section": "account",
    "guide": "/guide/account/account-login"
  },
  {
    "name": "프로필 · 학교 등록",
    "route": "/account/profile",
    "section": "account",
    "guide": "/guide/account/account-profile"
  },
  {
    "name": "포인트",
    "route": "/points",
    "section": "account",
    "guide": "/guide/account/account-points"
  },
  {
    "name": "개별 데이터 안심 조회",
    "route": "/workmate/data-lookup",
    "section": "workmate",
    "guide": "/guide/workmate"
  },
  {
    "name": "저요! 발표 버저",
    "route": "/classmate/buzzer",
    "section": "classmate",
    "guide": "/guide/classmate"
  },
  {
    "name": "모둠 매칭",
    "route": "/classmate/group-match",
    "section": "classmate",
    "guide": "/guide/classmate"
  },
  {
    "name": "오답노트 생성기",
    "route": "/classmate/wrong-answer-note",
    "section": "classmate",
    "guide": "/guide/classmate"
  }
] as const;
